import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ShieldCheckIcon } from '@heroicons/react/24/outline';
import SEO from '../components/SEO';
import PageHeader from '../components/PageHeader';
import SchemaMarkup from '../components/SchemaMarkup';

export default function Privacy() {
  const { t, i18n } = useTranslation();
  const langPrefix = i18n.language === 'et' ? '/et' : '/en';
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Safely get sections array
  const sections = t('privacy_page.sections', { returnObjects: true });
  const safeSections = Array.isArray(sections) ? sections : [];

  return (
    <div className="bg-slate-50 min-h-screen pb-20">
      <SEO 
        title={t('privacy_page.title')} 
        description={t('privacy_page.meta_desc')} 
        
      />

      <SchemaMarkup 
        type="webpage" 
        data={{
          title: t('privacy_page.title'),
          description: t('privacy_page.meta_desc'),
          url: `${langPrefix}/privacy`
        }} 
      />

      <PageHeader 
        title={t('privacy_page.title')} 
        subtitle={t('privacy_page.last_updated')}
        maxWidth="max-w-4xl"
      />

      <div className="container mx-auto px-4 py-12 md:py-16 max-w-4xl">
        <div className="bg-white rounded-3xl shadow-xl shadow-slate-200/50 p-8 md:p-12 border border-slate-100">
          
          {/* Header Icon */}
          <div className="w-16 h-16 bg-blue-50 text-blue-600 rounded-2xl flex items-center justify-center mb-8">
            <ShieldCheckIcon className="w-8 h-8" />
          </div>

          <div className="prose prose-lg prose-slate max-w-none">
            <p className="text-xl text-slate-600 leading-relaxed mb-10 border-b border-slate-100 pb-10">
              {t('privacy_page.intro')}
            </p>

            {/* Dynamic Sections */}
            <div className="space-y-10">
              {safeSections.map((section, index) => (
                <div key={index}>
                  <h3 className="text-xl font-bold text-slate-900 mb-4">
                    {section.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed whitespace-pre-line">
                    {/* Render text and handle bold markdown manually if needed, 
                        or just rely on clean text. 
                        Here we use a simple replacement for **bold** just in case */}
                    {section.content.split('**').map((part, i) => 
                      i % 2 === 1 ? <strong key={i} className="text-slate-900">{part}</strong> : part
                    )}
                  </p>
                </div>
              ))}
            </div>

            {/* Footer Contact */}
            <div className="mt-12 pt-8 border-t border-slate-100 bg-slate-50 -mx-8 -mb-8 md:-mx-12 md:-mb-12 p-8 md:p-12 rounded-b-3xl">
              <h4 className="font-bold text-slate-900 mb-2">{t('privacy_page.contact_title')}</h4>
              <p className="text-slate-600 mb-4">{t('privacy_page.contact_text')}</p>
              <a href="mailto:info@mupax.eu" className="text-blue-600 font-bold hover:underline">
                info@mupax.eu
              </a>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}